import { Grid } from '@mui/material';
import { useCallback, useState } from 'react';
import { deleteOutsourceCompany, getAllOutsourceCompanies } from '../../../../api/transports';
import useFetchList from '../../../../hooks/useFetchList';
import { useSelector } from '../../../../redux/store';
import { ConfirmDialog } from '../../../../reusable-components/confirm-dialog';
import CustomDataGrid from '../../../../reusable-components/datagrid/CustomDataGrid';
import { outsourceCompanyColumns } from '../../../../reusable-components/datagrid/outsourceCompanyColumns';
import { useSnackbar } from '../../../../reusable-components/snackbar';
import OutsourceCompanyModal from './OutsourceCompanyModal';

export default function OutsourceCompanies() {
  const { enqueueSnackbar } = useSnackbar();
  // Outsource Companies
  const [refreshKey, setRefreshKey] = useState(1);
  const [outsourceCompanies, outsourceLoading, outsourceError] = useFetchList(
    getAllOutsourceCompanies,
    [refreshKey],
    []
  );
  const transportsState = useSelector((state) => state.transports);
  const facilities = transportsState?.data?.facilities ?? [];
  const facilityDataIsLoading = transportsState?.isLoading ?? false;
  // Preprocess outsourceCompanies to add facilityName
  const processedCompanies = outsourceCompanies.map((company) => {
    const facility = facilities.find((f) => f.value === company.facilityId);
    return {
      ...company,
      facilityName: facility ? facility.label : '',
    };
  });

  const customToolbar = useCallback(
    () => (
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end">
        <OutsourceCompanyModal onAdded={() => setRefreshKey((k) => k + 1)} />
      </Grid>
    ),
    []
  );

  const handleDelete = async (id) => {
    try {
      const response = await deleteOutsourceCompany(id);
      const result = response.data;
      if (result.success) {
        enqueueSnackbar('Outsource Company deleted successfully', { variant: 'success' });
        setRefreshKey((k) => k + 1);
      } else {
        enqueueSnackbar(result.message || 'Failed to delete Outsource Company', { variant: 'error' });
      }
    } catch (error) {
      const errorMsg = 'Failed to delete Outsource Company';
      enqueueSnackbar(errorMsg, { variant: 'error' });
    }
  };

  const ActionButtons = (params) => (
    <>
      <OutsourceCompanyModal edit row={params.row} onAdded={() => setRefreshKey((k) => k + 1)} />

      {/* <ConfirmDialog
        icon="delete-outline"
        title="Delete"
        color="error"
        content={`Are you sure you want to delete ${params.row.name}?`}
        actionButton="Delete"
        action={() => handleDelete(params.row.id)}
        tooltip={`Delete`}
      /> */}
    </>
  );

  const actions = {
    field: 'actions',
    headerName: 'Actions',
    disableReorder: true,
    width: 180,
    renderCell: (params) => ActionButtons(params),
    id: 'actions',
    className: 'actions',
  };

  return (
    <>
      <Grid item xs={12}>
        <CustomDataGrid
          gridId="transports-outsource-companies"
          boxSX={{ height: 'calc(100vh - 225px)' }}
          data={processedCompanies}
          gridColumns={[...outsourceCompanyColumns, actions]}
          CustomLeftToolbar={customToolbar}
          getRowId={(row) => `${row.id}`}
          isLoading={facilityDataIsLoading || outsourceLoading}
        />
      </Grid>
    </>
  );
}
